import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, FileText, Gamepad2, ClipboardCheck, Users, Trophy, ListChecks } from 'lucide-react';
export function WhatIncludesSection() {
  const features = [{
    icon: Users,
    title: 'Actividades físicas organizadas por nivel'
  }, {
    icon: Calendar,
    title: 'Planificación anual lista para usar'
  }, {
    icon: FileText,
    title: 'Guiones completos de clase'
  }, {
    icon: Gamepad2,
    title: 'Juegos deportivos y recreativos'
  }, {
    icon: ClipboardCheck,
    title: 'Evaluaciones físicas estructuradas'
  }, {
    icon: Users,
    title: 'Actividades para grupos grandes y pequeños'
  }, {
    icon: Trophy,
    title: 'Proyectos deportivos escolares'
  }];
  const classIncludes = ['Objetivo de la actividad', 'Material necesario', 'Explicación paso a paso', 'Variaciones según edad', 'Consejos para mejorar la dinámica del grupo'];
  return <section className="py-20 bg-[#143524]" data-id="element-481">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-482">
        <div className="text-center mb-16" data-id="element-483">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-484">
            Esto es exactamente lo que recibís con el MegaPack:
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-485">
          {features.map((feature, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[#0C2818] p-6 rounded-2xl border border-[#1E4D2B] flex items-center gap-4 hover:border-[#FBBF24]/50 transition-colors" data-id="element-486">
              <div className="bg-[#16A34A]/20 p-3 rounded-xl" data-id="element-487">
                <feature.icon className="w-6 h-6 text-[#16A34A]" data-id="element-488" />
              </div>
              <h3 className="text-white font-bold text-lg" data-id="element-489">{feature.title}</h3>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#0C2818] rounded-3xl p-8 md:p-12 border border-[#FBBF24]/30 max-w-4xl mx-auto relative overflow-hidden" data-id="element-490">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#FBBF24] opacity-5 rounded-full blur-3xl" data-id="element-491"></div>

          <h3 className="text-2xl font-bold text-[#FBBF24] mb-8 flex items-center gap-3" data-id="element-492">
            <ListChecks className="w-8 h-8" data-id="element-493" />
            Cada clase incluye:
          </h3>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-494">
            {classIncludes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-495">
                <div className="w-2 h-2 rounded-full bg-[#16A34A] mt-2 flex-shrink-0" data-id="element-496"></div>
                <span className="text-gray-300 text-lg" data-id="element-497">{item}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}